<template>
	<v-row dense>
		<v-col cols="12">
			<v-btn
				v-model="filename"
				:append-icon="icon"
				:disabled="disabled"
				color="success"
				class="text-none mx-1"
				@click.native="onFocus"
			>
				<template>PC</template>
			</v-btn>
			<v-btn color="success" class="text-none mx-1" disabled>Camera</v-btn>
			<v-btn v-if="file" color="success" class="text-none mx-1" @click="file = null">Edit image</v-btn>
		</v-col>

		<v-col v-show="false" cols="12">
			<v-text-field v-model="filename" :rules="required ? [rules.required] : []"></v-text-field>
		</v-col>

		<v-col cols="12">
			<input
				ref="fileInput"
				type="file"
				:accept="accept"
				:disabled="disabled"
				style="display: none;"
				@change="onFileChange"
			/>
		</v-col>

		<v-col v-if="file" cols="12">
			<v-img :src="file | toUrl" alt="Retina" height="200" contain position="left"></v-img>
			<span v-if="file.name">File name: {{ file.name }}</span>
		</v-col>
	</v-row>
</template>

<script>
import rulesMixin from "../../mixins/rules-mixin";

export default {
	filters: {
		toUrl(file) {
			console.log(file);
			if (file == null) return "";

			return URL.createObjectURL(file);
		}
	},
	mixins: [rulesMixin],
	props: {
		icon: {
			type: String,
			default: "mdi-paperclip"
		},
		value: {
			type: File
		},
		accept: {
			type: String,
			default: "image/*"
		},
		label: {
			type: String,
			default: "Please choose..."
		},
		required: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			filename: "",
			file: null
		};
	},
	watch: {
		file(v) {
			this.filename = v.name;
			this.$emit("input", v);
		}
	},
	methods: {
		onFocus() {
			if (!this.disabled) {
				this.$refs.fileInput.click();
			}
		},
		onFileChange($event) {
			const files = $event.target.files || $event.dataTransfer.files;
			this.file = files[0];
		}
	}
};
</script>
